import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { requireSuperAdmin } from "@/features/auth/permissions/requireSuperAdmin";
import { MbcAdminPage } from "@/features/mbc-admin";
import { usePageTitle } from "@/hooks/usePageTitle";

export const Route = createFileRoute("/_auth/_app-shell/admin/mbc/")({
  beforeLoad: ({ context }) => requireSuperAdmin(context),
  component: RouteComponent,
  validateSearch: z.object({
    tab: z.enum(["guidelines", "checks"]).catch("guidelines"),
  }),
});

function RouteComponent() {
  usePageTitle("MBC Settings");

  return <MbcAdminPage />;
}
